import ClientUtils from "./../../../utils/ClientUtils";
import { useState } from "react";
import {
  FieldErrors,
  FieldValues,
  Path,
  RegisterOptions,
  UseFormRegister,
} from "react-hook-form";

import { UUID } from "@eljouren/utils";

type Props<T extends FieldValues> = {
  name: Path<T>;
  label?: string;
  errorMessage?: string;
  fontNormal?: string;
  errors?: FieldErrors<T>;
  className?: string;
  register: UseFormRegister<T>;
  options?: RegisterOptions<T>;
  htmlAttributes?: Omit<JSX.IntrinsicElements["input"], "ref">;
  labelClassName?: string;
} & (
  | {
      type: "checkbox";
      value?: undefined;
    }
  | { type: "radio"; value: string | number }
);

export function AppFormCheckbox<T extends FieldValues>(props: Props<T>) {
  const [id] = useState(UUID.generate().value);

  /*   const getError = () => {
    if (props.errorMessage) {
      return props.errorMessage;
    } else if (props.errors) {
      const errors = props.errors as any;
      if (props.name in errors) {
        return errors[props.name]?.message;
      }
    }

    return null;
  };
  const error = getError(); */

  return (
    <p
      className={ClientUtils.twClassNames(
        "grid grid-cols-[auto,minmax(0,1fr)] items-center gap-4",
        props.className
      )}
    >
      <input
        className={ClientUtils.twClassNames(
          !props.htmlAttributes?.disabled && "cursor-pointer",
          "p-2 disabled:opacity-50 disabled:brightness-75",
          "h-4 w-4"
        )}
        id={id}
        {...props.register(props.name, props.options)}
        {...props.htmlAttributes}
        type={props.type}
        value={props.value}
      ></input>
      {props.label && (
        <label
          htmlFor={id}
          className={ClientUtils.twClassNames(
            !props.htmlAttributes?.disabled && "cursor-pointer",
            props.labelClassName,
            !props.labelClassName && "text-lg"
          )}
        >
          {props.label}
        </label>
      )}

      {/* {error && <span>{error}</span>} */}
    </p>
  );
}
